import React from 'react'
import FormControlLabel from '@mui/material/FormControlLabel'
import Switch, { SwitchProps } from '@mui/material/Switch'
type Props = SwitchProps & {
  label?: string
}

export function CustomSwitch(props: Props) {
  const { label, ...rest } = props
  return (
    <FormControlLabel
      sx={{
        marginBottom: 0,
        gap: (theme) => theme.spacing(0.8),
      }}
      labelPlacement="end"
      label={label}
      control={<Switch {...rest} />}
    />
  )
}
